import { VideoPlayer } from './VideoPlayer';

// ID YouTube VSL — extrait de https://youtu.be/Q5F8jepIKS8
const VSL_VIDEO_ID = 'Q5F8jepIKS8';

export const VSLSection = () => {
  return (
    <div data-testid="vsl-section" className="w-full">
      <VideoPlayer
        videoId={VSL_VIDEO_ID}
        ratio="16:9"
        title="Vidéo de présentation HDA"
        thumbnail="/assets/vsl_thumb.jpg"
      />
    </div>
  );
};

export default VSLSection;
